import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import configureStore from './store/ConfigStore';
import App from './App';
import { Provider } from 'react-redux';
import moment from 'moment-timezone';

// Get the application-wide store instance,
// prepopulating with state from the server where available.
const initialState = window.initialReduxState;
const store = configureStore(initialState);

const container = document.getElementById('root');
const root = createRoot(container);

moment.tz.setDefault('Europe/Copenhagen');

root.render(
    <Provider store={store}>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </Provider>
);
